import React from "react";

const Copy = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M10.321 8.4V3.6c0-.424.167-.831.463-1.131A1.57 1.57 0 0111.9 2h18.963c.42 0 .821.169 1.118.469.296.3.462.707.462 1.131V26c0 .424-.166.831-.462 1.131a1.57 1.57 0 01-1.118.469h-4.74v4.8c0 .883-.712 1.6-1.592 1.6H5.592a1.566 1.566 0 01-1.125-.465A1.602 1.602 0 014 32.4L4.005 10c0-.883.71-1.6 1.591-1.6h4.725zm-3.156 3.2L7.16 30.8h15.803V11.6H7.165zm6.317-3.2h12.642v16h3.16V5.2H13.482v3.2z"
          fill={fill}
      />
    </svg>
);

export default Copy;
